import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateWorkersPagination } from '../../store/actions/worker/worker_action';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import WorkersTable from './workers_table';
import SearchComponent from '../ui_components/search';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const WorkerList = ({ workers }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = workers;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateWorkersPagination({...workers, page: 0, filters: { ...filters, search }}))
    }

    const handleAddWorkerClick = () => {
        history.push(REACT_ROUTES.WORKER);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Radnici
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddWorkerClick}
                    >
                        Kreirajte novog radnika
                    </Button>
                </Grid>
            </Grid>
            <WorkersTable/>
        </Container>
    )
}

WorkerList.propTypes = {
    workers: PropTypes.object
}

const mapStateToProps = (state) => ({
    workers: state.workers
});

export default connect(mapStateToProps)(WorkerList);
